import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConstantValues } from "../../common/constant-values";
import { BaseResponse } from "../../models/commonResponse";
import { environment } from "../../../environments/environment";
import { RequestService } from "./request.service";
import { BehaviorSubject, Observable } from "rxjs";
import { SelectOption } from "../../models/adminmanagement/AdminRole";
import { DivisionTownshipNrcListResponse } from "../../models/data-store.model";
import { PaymeAgentUser } from "../../models/agentmanagement/agentmanagement";
import { head } from "lodash";


@Injectable({
    providedIn: 'root'
})
export class AppService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-typ': 'application/json',
            // "Authorization": "Bearer " + this.
        })
    }

    constructor(private http: HttpClient, private requestService: RequestService) { }

    baseAPIUrl = environment.baseAPIUrl + "/" + environment.apiVer;
    mobileAPIUrl = environment.mobileAPIUrl + "/" + environment.apiVer;
    middleWareAPIUrl = environment.middleWareAPIUrl + "/" + environment.apiVer;

    //#region nrc && address (division + township)
    private nrcDivisionListSubject = new BehaviorSubject<SelectOption[]>([]);
    nrcDivisionList$ = this.nrcDivisionListSubject.asObservable();

    private nrcTownshipCodeListSubject = new BehaviorSubject<SelectOption[]>([]);
    nrcTownshipCodeList$ = this.nrcTownshipCodeListSubject.asObservable();

    private nrcNationalityCodeListSubject = new BehaviorSubject<SelectOption[]>([]);
    nrcNationalityCodeList$ = this.nrcNationalityCodeListSubject.asObservable();

    

    private addressTownshipListSubject = new BehaviorSubject<SelectOption[]>([]);
    addressTownshipList$ = this.addressTownshipListSubject.asObservable();

    private addressDivisionListSubject = new BehaviorSubject<SelectOption[]>([]);
    addressDivisionList$ = this.addressDivisionListSubject.asObservable();

    updateNrcDivisionList(options: SelectOption[]) {
        this.nrcDivisionListSubject.next(options);
    }

    updateNrcTownshipCodeList(options: SelectOption[]) {
        const currentList = this.nrcTownshipCodeListSubject.getValue();
        this.nrcTownshipCodeListSubject.next([...currentList, ...options]);
    }

    updateNrcNationalityCodeList(options: SelectOption[]) {
        this.nrcNationalityCodeListSubject.next(options);
    }

    updateAddressTownshipList(options: SelectOption[]) {
        const currentList = this.addressTownshipListSubject.getValue();
        this.addressTownshipListSubject.next([...currentList, ...options]);
    }

    updateAddressDivisionList(options: SelectOption[]) {
        this.addressDivisionListSubject.next(options);
    }
    //#endregion

    addDefaultOptionValue(options: SelectOption[]): SelectOption[] {
        var op:SelectOption[] = JSON.parse(JSON.stringify(options)); // make sure to not affect the origin value 
        op.unshift({
            Value: '',
            Label: '---',
            Parent: ''
        });
        return op;
    }
    

    //#region  get options from backend
    getNRCData(divisionCode: string | null):Observable<BaseResponse<DivisionTownshipNrcListResponse>>  {

        const msgData = divisionCode? { NRCDivisionCode: divisionCode} : {};

        const request = this.requestService.createBaseRequest(ConstantValues.GET_TOWNSHIPSBYDIVISION, msgData);

        return this.http.post<BaseResponse<DivisionTownshipNrcListResponse>>(
            this.baseAPIUrl + `nrc/nrcinfo`, msgData, this.httpOptions
        );
    }

    getcashoutsource():Observable<BaseResponse<DivisionTownshipNrcListResponse>> {
        console.log('this.baseAPIUrl + `paymeusers/getcashoutsource`', this.baseAPIUrl + `paymeusers/getcashoutsource`)
        return this.http.get<BaseResponse<DivisionTownshipNrcListResponse>>(
            this.baseAPIUrl + `paymeusers/getcashoutsource`, this.httpOptions
        );
    }

    getAddressTownshipByDivision(divisionCode: string):Observable<BaseResponse<DivisionTownshipNrcListResponse>> {
        const msgData = {
            DivisionId: divisionCode
        };
        
        const request = this.requestService.createBaseRequest(ConstantValues.GET_ADDRESS_TOWNSHIP_LIST, msgData);

        return this.http.post<BaseResponse<DivisionTownshipNrcListResponse>>(
            this.baseAPIUrl + `township/addresstownshipbydivision`, msgData, this.httpOptions
            // this.baseAPIUrl + `division/addresstownshipbydivision`, msgData, this.httpOptions
        );
    }

    // This addresstownship in region created new endpoint by May Thu Kyaw
    getDivisionInRegion():Observable<BaseResponse<DivisionTownshipNrcListResponse>> { 
        // const request = this.requestService.createBaseRequest(ConstantValues.GET_ADDRESS_TOWNSHIP_LIST, msgData);
        return this.http.get<BaseResponse<DivisionTownshipNrcListResponse>>(
            this.baseAPIUrl + `division/divisionoptions `, this.httpOptions
        );
    }

    getDivisionOptionList() {
        const request = this.requestService.createBaseRequest(ConstantValues.GET_DIVISIONS_LIST, {});
    
        return this.http.get<BaseResponse<any>>(this.baseAPIUrl + 'divisions/optionlist', this.httpOptions);
    }

      //#endregion


    updateAgentInfo(data: PaymeAgentUser, tokenAuth: any, deviceId: string, loginRequestUserId: string){
        var requestId  = Array.from({length:8}, () => Math.floor(Math.random()*10)).join('');
        let header = {
        'Authorization': 'Bearer ' + tokenAuth.AccessToken,
        'X-Agent-Code': 'payme-pension-web',
        'X-API-Key': 'AKIA4HKPOKZLMYUSPWVB',
        'X-Session-Id': tokenAuth.SessionId,
        'X-Device-Id': deviceId,
        'X-Channel': 'PayMeWeb',
        'Content-Type': 'application/json',
        'Accept': '*/*'
        };
        let httpOptions = {
            headers: new HttpHeaders(header)
        }
        return this.http.post<any>(
                this.mobileAPIUrl + `/agents/update`, data, httpOptions
            );
    }
}